import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { CustomerBillings } from "./CustomerBillings";
import CustomerBillingsQueryNode, {
  type CustomerBillingsQuery$variables,
} from "./__generated__/CustomerBillingsQuery.graphql";

const entryPoint: SimpleEntryPoint<typeof CustomerBillings> = {
  root: JSResource("CustomerBillings", () =>
    import("./CustomerBillings").then((module) => module.CustomerBillings),
  ),
  getPreloadProps({ params }) {
    const customerId = params.customerId!;
    const variables: CustomerBillingsQuery$variables = {
      customerId,
      onlyCustomer: [customerId],
    };

    return {
      queries: {
        query: {
          parameters: CustomerBillingsQueryNode,
          variables,
          options: {
            fetchPolicy: "store-and-network",
          },
        },
      },
    };
  },
};

export default entryPoint;
